import api from './apiClient';

// 🔄 1. Fetch all meal plans
export async function fetchAllPlans() {
  const response = await api.get('/api/planning');
  return response.data; // returns: [ { ...plan } ]
}

// ➕ 2. Create a new meal plan
export async function addPlan(planData) {
  const response = await api.post('/api/planning', planData);
  return response.data; // returns: { ...newPlan }
}

// ❌ 3. Delete a meal plan by ID
export async function deletePlan(planId) {
  return api.delete(`/api/planning/${planId}`);
}

// 🔍 4. Get a single meal plan's details
export async function fetchPlanById(planId) {
  const response = await api.get(`/api/planning/${planId}`);
  return response.data; // returns: { ...planDetails }
}

// 🍽 5. Add a recipe to a meal plan
export async function addRecipeToPlan(planId, recipeEntry) {
  const response = await api.post(`/api/planning/${planId}/add-recipe`, recipeEntry);
  return response.data; // returns: confirmation or updated plan
}

// 🧬 6. Duplicate an existing plan
export async function duplicatePlan(planId) {
  const response = await api.post(`/api/planning/${planId}/duplicate`);
  return response.data; // returns: new duplicated plan
}

// 🛒 7. Get grocery list for a meal plan
export async function fetchGroceryList(planId) {
  const response = await api.get(`/api/planning/${planId}/grocery-list`)

  console.log("📦 backend response", response.data)

  const inner = response.data.ingredients || {}  // unwrap the nested object

  return {
    items: inner.items ?? [],                     // ✅ fix here
    missing_ingredients: inner.missing_ingredients ?? []
  }
}

// ❌ 8. Remove a recipe from a meal plan
export async function removeRecipeFromPlan(planId, entryId) {
  return api.delete(`/api/planning/${planId}/remove-recipe/${entryId}`);
}